import { format } from "date-fns";
import { MdCheck } from 'react-icons/md'

const AvailabilityInfoTabCenterGutter = ({family}) => {
    
    const time = ['Morning', 'Afternoon', 'Evening']

    return (
        <div>{
            family.initialAvailability ?
            <div>
            <div className='scheduling-tab-fall-2023__suggestions-label'>Initial Availability on {format(new Date(family.onboardDate), 'MMMM dd, yyyy')}</div>
                {family.initialAvailability &&
                    <div className='scheduling-tab-fall-2023__availability-wrapper'>
                        <div className='scheduling-tab-fall-2023__time-of-day-column-labels'>
                            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Morning</div>
                            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Afternoon</div>
                            <div className='scheduling-tab-fall-2023__time-of-day-column-label'>Evening</div>
                        </div>
                        {Object.keys(family.initialAvailability).map((day, index) => (
                            (family.initialAvailability[day]['Morning'] || family.initialAvailability[day]['Afternoon'] || family.initialAvailability[day]['Evening']) &&
                            <div className='scheduling-tab-fall-2023__day-wrapper' key={index}>
                                <div className='scheduling-tab-fall-2023__day-label'>{day.slice(0, 3)}</div>
                                <div className='scheduling-tab-fall-2023__time-wrapper'>
                                    {time.map((timeOfDay, index) => (
                                        <div className='scheduling-tab-fall-2023__time-label' key={index}>
                                           {family.initialAvailability[day][timeOfDay] === true ? 
                                           <div className='scheduling-tab-fall-2023__check-box' style={{border: '1px solid #14B8A6', backgroundColor: '#CCFBF1'}}>
                                               <MdCheck size={20} fill='#14B8A6' /> 
                                           </div>: 
                                           <div className='scheduling-tab-fall-2023__check-box'></div>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                }
        </div>
        :
        <div>Unavailable, sorry</div>
        }
        </div>
    );
}
export default AvailabilityInfoTabCenterGutter;